import { useMutation } from '@gogame/query';

import { updateDynamicData } from 'scenes/Trackers/Tracker/sources/dynamicData';

import { updateDynamicDataKey, grids } from '../queryKeyFactory';

export const useUpdateDynamicData = () => {
  const updateDynamicDataMutation = useMutation(
    updateDynamicDataKey(),
    updateDynamicData,
    {
      refreshOptions: {
        queryKey: grids(),
        useInvalidate: true,
      },
    }
  );

  return [updateDynamicDataMutation.mutateAsync, updateDynamicDataMutation];
};
